import { render } from "./AyudaAlergiaPers.vue?vue&type=template&id=7c2960b8&scoped=true"
import script from "./AyudaAlergiaPers.vue?vue&type=script&lang=js"
export * from "./AyudaAlergiaPers.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=7c2960b8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2960b8"]])

export default __exports__